import { FC } from "react";
import { Link, useLocation } from "react-router-dom";

import "./style.css";

interface Props {
    className?: string;
    to?: string;
    label: string;
    Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

const NavItem: FC<Props> = ({ className, to, label, Icon }) => {
    const location = useLocation();

    if (to) {
        // Highlight only if exact match or if pathname starts with 'to' and next char is '/' or nothing (to avoid /payouts matching /admin/payouts)
        const isActive = location.pathname === to ||
            (to !== '/' && location.pathname.startsWith(to + '/'));
        return (
            <Link
                to={to || ""}
                className={`nav_item${isActive ? " nav_item-active" : ""}${className ? ` ${className}` : ""}`}
            >
                {Icon && <Icon className="nav_logo" />}
                <p>{label}</p>
            </Link>
        );
    } else {
        return (
            <div className={`nav_item${className ? ` ${className}` : ""}`}>
                {Icon && <Icon className="nav_logo" />}
                <p>{label}</p>
            </div>
        );
    }
};

export default NavItem;
